/* Merk "Algemeen" info-tooltip — popover aan <body> (geen clipping in kaarten), hover + tap.
   Inhoud is conditie-afhankelijk en komt per knop uit data-attributen (titel/body/note). */
(function () {
  if (window.__rwBrandInfo) return; window.__rwBrandInfo = 1;
  var FALLBACK = "Merkloos artikel zonder specifiek merk. Daarom verkopen we het onder 'Algemeen'.";
  var pop, el = {}, cur;
  function ensure() {
    if (pop) return;
    pop = document.createElement('div');
    pop.className = 'rw-brandi-pop';
    pop.setAttribute('role', 'tooltip');
    pop.innerHTML = '<span class="rw-brandi-pop__arw"></span>' +
      '<strong class="rw-brandi-pop__title"></strong>' +
      '<span class="rw-brandi-pop__body"></span>' +
      '<span class="rw-brandi-pop__note"></span>';
    el.arw = pop.querySelector('.rw-brandi-pop__arw');
    el.title = pop.querySelector('.rw-brandi-pop__title');
    el.body = pop.querySelector('.rw-brandi-pop__body');
    el.note = pop.querySelector('.rw-brandi-pop__note');
    document.body.appendChild(pop);
  }
  function fill(btn) {
    var t = btn.getAttribute('data-rw-brandi-title') || '';
    var b = btn.getAttribute('data-rw-brandi-body') || FALLBACK;
    var n = btn.getAttribute('data-rw-brandi-note') || '';
    el.title.textContent = t; el.title.hidden = !t;
    el.body.textContent = b;
    el.note.textContent = n; el.note.hidden = !n;
  }
  function place(btn) {
    var r = btn.getBoundingClientRect(), pw = pop.offsetWidth, ph = pop.offsetHeight, m = 8;
    var vw = document.documentElement.clientWidth, vh = document.documentElement.clientHeight;
    var left = r.left + window.scrollX;
    if (left + pw > window.scrollX + vw - m) left = window.scrollX + vw - m - pw;
    if (left < window.scrollX + m) left = window.scrollX + m;
    var below = r.bottom + 9 + ph <= vh - m || r.top < ph + 12;
    var top = below ? (r.bottom + window.scrollY + 9) : (r.top + window.scrollY - ph - 9);
    pop.classList.toggle('rw-brandi-pop--up', !below);
    pop.style.left = left + 'px'; pop.style.top = top + 'px';
    var ax = r.left + r.width / 2 + window.scrollX - left;
    el.arw.style.left = Math.max(12, Math.min(pw - 12, ax)) + 'px';
  }
  function show(btn) {
    ensure(); fill(btn);
    pop.classList.add('is-open'); place(btn); cur = btn; btn.setAttribute('aria-expanded', 'true');
  }
  function hide() { if (pop) pop.classList.remove('is-open'); if (cur) cur.setAttribute('aria-expanded', 'false'); cur = null; }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-rw-brandi]');
    if (b) { e.preventDefault(); e.stopPropagation(); if (cur === b) hide(); else show(b); return; }
    if (cur) hide();
  });
  if (window.matchMedia && window.matchMedia('(hover:hover)').matches) {
    document.addEventListener('mouseover', function (e) { var b = e.target.closest('[data-rw-brandi]'); if (b && cur !== b) show(b); });
    document.addEventListener('mouseout', function (e) { var b = e.target.closest('[data-rw-brandi]'); if (b && !b.contains(e.relatedTarget)) hide(); });
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
  window.addEventListener('scroll', function () { if (cur) hide(); }, true);
  window.addEventListener('resize', function () { if (cur) hide(); });
})();
